export default "__VITE_ASSET__7bbfd831__"